export default __webpack_public_path__ + "./images/cy.aed10939.png";